import { AlloyResponsePropositions } from "./typeDefinitions";

export class DecisionsDisplayedEvent<TContent = object> {
  event = 'decisions displayed' as const;
  propositions: AlloyResponsePropositions<TContent>[];

  constructor(decisionsDisplayedData: AlloyResponsePropositions<TContent>[]) {
    this.propositions = decisionsDisplayedData;
  }
}
